import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import styles from '../Dashboards.module.css';
import Spinner from '../../common/Spinner';
import { useAhaPanelContents, useHtmlSnapshot } from '../hooks';
import AhaContents from './AhaContents';
import useResizeObserver from 'components/hooks/useResizeObserver';
import customElementBoolAttr from 'javascripts/util/customElementBoolAttr';

const DevelopChart = ({ panel, preview, bookmarkId, filters, ariaLabel }) => {
  const shouldUseHtmlSnapshot = useHtmlSnapshot();
  const ahaContents = useAhaPanelContents({
    panel,
    bookmarkId,
    preview,
    filters,
    showLegend: panel.showLegend,
    dashboardFilter: panel.dashboardFilter,
    bookmarkStartDate: panel.bookmarkStartDate,
    bookmarkEndDate: panel.bookmarkEndDate,
  });

  let panelContent;
  if (ahaContents || shouldUseHtmlSnapshot) {
    panelContent = <AhaContents ahaContents={ahaContents} />;
  } else {
    panelContent = <Spinner />;
  }

  // The burndown chart manually sets its height on load -
  // when the panel resizes we need to update the height.
  const resizeCallback = useCallback(
    (element, _entries) => {
      if (!element || !(shouldUseHtmlSnapshot || ahaContents)) return;

      const chartNode = element.getElementsByClassName(
        'develop-chart'
      )[0] as HTMLDivElement;

      if (chartNode) {
        const height = element.getBoundingClientRect().height || 0;
        chartNode.style.height = `${height}px`;
      }
    },
    [shouldUseHtmlSnapshot, ahaContents]
  );

  const contentRef = useResizeObserver(resizeCallback);

  const isLoading = !ahaContents && !shouldUseHtmlSnapshot;

  return (
    <div
      className={styles.PanelContent}
      aria-label={ariaLabel}
      ref={contentRef}
      data-async-loading={customElementBoolAttr(isLoading)}
    >
      {panelContent}
    </div>
  );
};

const mapStateToProps = state => ({
  bookmarkId: state.getIn(['meta', 'bookmarkId']),
  filters: state.getIn(['meta', 'filters']),
});

export default connect(mapStateToProps)(DevelopChart);
